<template>
    <div class="installt">
        <div class="intext"> {{ stname }}{{ type == 1 ? '规格' : '参数' }} </div>
        <div class="addpopers">
            <!-- <div class="addpoper" @click="openDialog">
                <div> <el-icon :size="24" color="#fff">
                        <Plus style=" margin-right: 8px" />
                    </el-icon></div>
                <div style="height: 24px;">批量上架</div>

            </div> -->
            <div class="addpoper" @click="openDialog(false)">
                <div> <el-icon :size="24" color="#fff">
                        <Plus style=" margin-right: 8px" />
                    </el-icon></div>
                <div style="height: 24px;">规格属性</div>

            </div>
        </div>

    </div>
    <div class="stand">
        <div class="standmsg" v-for="(item, index) in standmsg" :key="index">
            <div class="msgtop">
                <div>{{ '规格属性' }}</div>
                <div @click="spec(item.id)"><el-icon color="#FD6A6A">
                        <Delete />
                    </el-icon></div>
            </div>
            <div class="shux">{{ item.sname || '颜色' }}</div>
            <div class="shunanme">
                <div class="shus" v-for="(item2, index) in item.specValues">
                    {{ item2 }}
                </div>

            </div>
            <div class="compiler" @click="openDialog(item)">
                编辑属性
            </div>

        </div>

    </div>
    <yc-mask ref="maskRef" :close-on-click-modal="false">
        <div class="dialog">
            <div class="dialogt">
                <div>
                    商品规格
                </div>
                <div @click="closeDialog">
                    <el-icon>
                        <Close />
                    </el-icon>
                </div>
            </div>
            <div>
                <div>属性名称</div>
                <div style="margin-top: 16px;margin-bottom: 16px;">
                    <input type="text" v-model="productSpecParameter.sname" placeholder="请输入属性名称">
                </div>

                <div>所属分类</div>
                <div style="margin-top: 16px;margin-bottom: 16px;">
                    <input type="text" disabled v-model="stname" placeholder="请输入属性名称">
                </div>
                <div>属性值可选列表</div>
                <div
                    style="margin-top: 16px;margin-bottom: 16px;width: 391px;height: 56px;background: #FAFAFA;display: flex;align-items: center;">
                    <el-tag style="margin-left: 12px;height: 32px;background: #F1F2F4;font-weight: 400;font-size: 16px;"
                        v-for="tag in productSpecParameter.specValues" :key="tag" closable :disable-transitions="false"
                        @close="handleClose(tag)">
                        {{ tag }}
                    </el-tag>
                    <el-input style="width: 100px;height: 32px;" v-if="inputVisible" ref="InputRef" v-model="inputValue"
                        class="w-20" size="small" @keyup.enter="handleInputConfirm" @blur="handleInputConfirm" />
                    <el-button style="height: 32px;"
                        v-else-if="!inputVisible && productSpecParameter.specValues.length <= 4" class="button-new-tag"
                        size="small" @click="showInput">
                        添加新属性
                    </el-button>
                </div>
                <div>排序</div>
                <div style="margin-top: 16px;margin-bottom: 16px;">
                    <input type="text" v-model="productSpecParameter.sort" placeholder="属性排序">
                </div>
                <div>能否进行检索</div>
                <div style="margin-bottom: 16px;width: 391px;height: 56px;display: flex;align-items: center;">
                    <el-radio-group v-model="productSpecParameter.retrieval" @change="radioel">
                        <el-radio :value="0" :label="0">不需要检索</el-radio>
                        <el-radio :value="1" :label="1">关键字检索</el-radio>
                        <el-radio :value="2" :label="2">范围检索</el-radio>
                    </el-radio-group>
                </div>
                <div
                    style="margin-bottom: 16px;width: 391px;height: 56px;display: flex;align-items: center;justify-content: space-between;">
                    <div>是否关联商品属性</div>
                    <div><el-switch v-model="productSpecParameter.goodspec" /></div>

                </div>
            </div>

            <div class="sybtom">

                <div class="quxiao" @click="closeDialog">取消</div>
                <div class="baochun" @click="baochun">保存</div>

            </div>

        </div>
    </yc-mask>
</template>

<script setup>
import api from "@/api/api";
import { onMounted, ref, nextTick, reactive } from "vue";
import { useRoute } from "vue-router";
import ycMask from '@/components/mask/mask.vue'
import { ElInput, ElMessage,ElMessageBox  } from 'element-plus'

const route = useRoute();
let id
let storeid
let stname = ref('')
let type

const inputValue = ref('')
const dynamicTags = ref(['Tag 1', 'Tag 2', 'Tag 3'])
const inputVisible = ref(false)
const InputRef = ref()
const radioel = (e) => {
    console.log(e)
}
const handleClose = (tag) => {
    // dynamicTags.value.splice(dynamicTags.value.indexOf(tag), 1)
    productSpecParameter.value.specValues.splice(productSpecParameter.value.specValues.indexOf(tag), 1)
}

const showInput = () => {
    inputVisible.value = true
    nextTick(() => {
        // InputRef.value!.input!.focus()
    })
}

const handleInputConfirm = () => {

    if (inputValue.value.length > 5) {
        ElMessage({
            message: '不能多余五个字！',
            type: 'warning',
        })
    } else {
        if (inputValue.value) {
            productSpecParameter.value.specValues.push(inputValue.value)
        }
        inputVisible.value = false
        inputValue.value = ''
    }


}
let add = false
const baochun = async () => {
    let msg = deepClone(productSpecParameter.value)
    msg.specValues = msg.specValues.join()

    msg.specId = msg.id
    delete msg.id
    msg.goodSpec = msg.goodspec
    delete msg.goodspec



    msg.specName = msg.sname
    delete msg.sname

    console.log(msg)
    let res
    if (add) {
        res = await api.specadd(msg)
    } else {
        res = await api.specPUT(msg)
    }
    console.log(res)
    if (res.success) {
        maskRef.value.closeMask();
        ElMessage({
            message: '保存成功！',
            type: 'success',
        })
        productSpec()
    } else {
        ElMessage.error(res.message)
    }
}

onMounted(() => {
    id = route.query.id
    storeid = route.query.storeId
    type = route.query.type
    stname.value = route.query.name
    console.log(id, storeid);
    productSpec()
});
let standmsg = ref([])
const productSpec = async () => {
    let data = {
        goodsTypeId: id,
        // storeId: storeid,
        pageSize:99,
        type: type
    }
    const res = await api.productSpec(data)
    standmsg.value = res.data.tlist


    for (let a = 0; a < standmsg.value.length; a++) {

        standmsg.value[a].specValues = (standmsg.value[a].specValues.split(','))
    }
    console.log('standmsg.value', standmsg.value)

}
const spec = (id) => {
    ElMessageBox.confirm('是否删除该规格？')
        .then(() => {
            detspec(id)
        })
        .catch(() => {
            // catch error
        })
}
const detspec = async (id) => {
    let data = {
        specId: id
    }
    const res = await api.spec(data)
    if (res.success) {
        ElMessage({
            message: '删除成功',
            type: 'success',
            onClose:()=>{
                productSpec()
            }
        })
    }else{
        ElMessage({
            message: '删除失败',
            type: 'warning',
           
        })
    }

}


//关闭弹窗
let closeDialog = () => {
    maskRef.value.closeMask();
};
//获取遮罩的实例
let maskRef = ref(null);
//导出的遮罩层
let productSpecParameter = ref({})
let openDialog = async (item) => {
    if (item) {
        let a = item
        productSpecParameter.value = deepClone(a)
        if (!productSpecParameter.value.retrieval) {
            productSpecParameter.value.retrieval = 0
        }
        console.log(productSpecParameter.value)
    } else {
        add = true
        productSpecParameter.value = {
            "class1": 0,
            "class2": 0,
            "class3": 0,
            "goodSpec": 0,
            "goodsTypeId": id,
            "optional": false,
            "retrieval": 0,
            "sort": null,
            "specId": id,
            "specName": "",
            "specValues": [],
            "storeId": storeid,
            "type": type - 1
        }
    }





    maskRef.value.showMask();
};
function deepClone(obj) {
    //判断 传入对象 为 数组 或者 对象
    var result = Array.isArray(obj) ? [] : {};
    // for in 遍历
    for (var key in obj) {
        // 判断 是否 为自身 的属性值（排除原型链干扰）
        if (obj.hasOwnProperty(key)) {
            // 判断 对象的属性值 中 存储的 数据类型 是否为对象
            if (typeof obj[key] === 'object') {
                // 有可能等于 null
                if (obj[key] === null) {
                    result[key] = null
                    continue
                }
                // 递归调用
                result[key] = deepClone(obj[key]);   //递归复制
            }
            // 不是的话 直接 赋值 copy
            else {
                result[key] = obj[key];
            }
        }
    }
    // 返回 新的对象
    return result;
}

</script>

<style lang="scss" scoped>
.installt {
    display: flex;
    height: 50px;
    justify-content: space-between;
    align-items: center;

    .intext {
        font-size: 32px;
        font-weight: 400;
        color: #0A1629;
    }

    .addpopers {
        display: flex;

        .addpoper {
            width: 132px;
            height: 48px;
            background: rgba(63, 140, 255);
            box-shadow: 0px 6px 12px 0px rgba(63, 140, 255, 0.26);
            border-radius: 8px;
            color: #FFFFFF;

            padding-left: 16px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            margin-left: 33px;
        }
    }

}

.stand {
    width: 100%;
    height: calc(100% - 50px - 14px - 15px);
    // background-color: antiquewhite;
    //     display: flex;
    //   flex-wrap: wrap;
    margin-left: -12px;

    .standmsg {
        width: 366px;
        height: 253px;
        background: #FFFFFF;
        border-radius: 8px;
        padding: 19px 28px 19px 24px;
        box-sizing: border-box;
        margin-left: 16px;
        float: left;
        margin-top: 15px;


        .msgtop {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-weight: 400;
            font-size: 16px;
            color: #111827;
        }

        .shux {
            font-weight: 400;
            font-size: 16px;
            color: #111827;
            margin-top: 26px;
        }

        .shunanme {
            width: 100%;
            height: 50px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 13px;
            flex-wrap: wrap;

            .shus {
                width: 88px;
                height: 32px;
                background: #FAFAFA;
                border-radius: 8px;
                font-weight: 500;
                font-size: 14px;
                color: #111827;
                text-align: center;
                line-height: 32px;
            }
        }

        .compiler {
            width: 100%;
            height: 56px;
            background: #FFFFFF;
            border: 1px solid #3F8CFF;
            text-align: center;
            line-height: 54px;
            font-weight: 400;
            font-size: 16px;
            color: #3F8CFF;
            border-radius: 8px;
            margin-top: 21px;
            cursor: pointer;
            transition:
                color 0.5s,
                background-color 0.5s,
        }

        .compiler:hover {
            background: #3F8CFF;
            color: #FFFFFF;
        }
    }
}

.dialog {
    position: relative;
    width: 491px;
    height: 769px;
    background: #FFFFFF;
    border-radius: 8px;
    overflow: hidden;
    padding: 0 42px 0 42px;
    box-sizing: border-box;
    font-size: 16px;

    .dialogt {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 16px;
        color: #111827;
        color: rgba(0, 0, 0, 0.88);
        margin-bottom: 20px;
        padding: 23px 0 0 0;
    }

    .sybtom {
        width: 100%;
        display: flex;
        justify-content: space-around;
        font-weight: 400;
        font-size: 17px;

        .quxiao {
            width: 121px;
            height: 51px;
            border: 1px solid #070707;
            border-radius: 8px;
            text-align: center;
            line-height: 51px;
            cursor: pointer;

            color: rgba(0, 0, 0, 0.85);
        }

        .baochun {
            cursor: pointer;

            color: #FFFFFF;
            width: 121px;
            height: 51px;
            background: #3686FF;
            border-radius: 8px;
            text-align: center;
            line-height: 51px;
        }
    }



}

input {
    // padding-left: 12px;
    font-size: 16px;
    color: #111827;
    outline: none;
    background: #FAFAFA;
    border: none;
    outline: medium;
    width: 100%;
    height: 50px;
    box-sizing: border-box;
}
</style>